import { render, staticRenderFns } from "./bo-mobile-catalog-dropdown.vue?vue&type=template&id=f741b0ca"
import script from "./bo-mobile-catalog-dropdown.vue?vue&type=script&lang=js"
export * from "./bo-mobile-catalog-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports